import http from "./http";
const remark = {
  getList() {
    return http.get("remark/listRemark");
  },

  getAll() {
    return http.get("remark/listRemark");
  },
  insert(model) {
    return http.post("remark/addRemark", model);
  },

  update(model) {
    return http.post("remark/editRemark", model);
  },

  delete(id) {
    let model = {
      remarkId: id,
      remarkContent: ''
    };
    return http.post("remark/delRemark", model);
  },
};
export default remark;
